module.exports = __webpack_public_path__ + "static/media/upland@3x.1a5b847b.jpg";